import { AfterContentChecked, AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSliderChange } from '@angular/material/slider';
import { DisplaySettings } from '../display-settings';
import * as settings from '../../common/settings';
import * as aspSettings from '../../asp/aspSettings';
import { constsMngr } from '../../common/consts';
import { ColorPickerComponent } from '@core_n/common/color-picker/color-picker.component';
import { ColorPickerService } from '@core_n/common/color-picker/color-picker.service';
import { MapMngr } from './../../asp/MapMngr';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import * as enums from './../../common/enums';
import { Animations } from '@core_n/Animations';

@Component({
  selector: 'tracks-settings',
  templateUrl: './tracks-settings.component.html',
  styleUrls: ['../display-filter.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})
export class TracksSettingsComponent extends ZIndexMngr implements AfterViewInit {
  @ViewChild('ipColorButton', { read: ElementRef }) private ipColorButton: ElementRef;
  @ViewChild('ipColorButtonSmt', { read: ElementRef }) private ipColorButtonSmt: ElementRef;
  @ViewChild('tpColorButton', { read: ElementRef }) private tpColorButton: ElementRef;
  @ViewChild('tpColorButtonSmt', { read: ElementRef }) private tpColorButtonSmt: ElementRef;
  @ViewChild('trackTextColorButton', { read: ElementRef }) private trackTextColorButton: ElementRef;
  @ViewChild('slider', { read: ElementRef }) private slider: ElementRef;

  private currentIpColor: string;
  private currentIpColorSmt: string;
  private currentTpColor: string;
  private currentTpColorSmt: string;
  private defaultStyleColor: string;
  private currentTextColor: string;

  static readonly DIALOG_ID = "tracksSettings";

  userPerm: enums.Permission;

  trackElements: string[] = [];
  sysTrackElements: string[] = [];
  snsTrackElements: string[] = [];
  angTrackElements: string[] = [];

  trackElementsOn = settings.userSettings.trackElementsOn;
  sysTrackElementsOn = settings.userSettings.sysTrackElementsOn;
  snsTrackElementsOn = settings.userSettings.snsTrackElementsOn;
  angTrackElementsOn = settings.userSettings.angTrackElementsOn;
  trackTrailLength = settings.userSettings.trackTrailLength;
  trackLifeTime = settings.userSettings.trackLifeTime;

  IpFillBrightness: number = settings.userSettings.IpFillOpacity * 100.0;
  textSize: number;
  trackTextToggler: boolean;

  color1 = "#ff0000";

  constructor(public dialogRef: MatDialogRef<TracksSettingsComponent>,
    private colorPickerSvc: ColorPickerService,
    elementRef: ElementRef,
    private cdr: ChangeDetectorRef) {
    super(elementRef);

    this.userPerm = settings.userSettings.userPerm;

    for (let i = 0; i < constsMngr.trackDisplayElementCount(); i++)
      this.trackElements.push(constsMngr.trackDisplayElementTitle(i));
    for (let i = 0; i < constsMngr.sysTrackDisplayElementCount(); i++)
      this.sysTrackElements.push(constsMngr.sysTrackDisplayElementTitle(i));
    for (let i = 0; i < constsMngr.snsTrackDisplayElementCount(); i++)
      this.snsTrackElements.push(constsMngr.snsTrackDisplayElementTitle(i));
    for (let i = 0; i < constsMngr.angTrackDisplayElementCount(); i++)
      this.angTrackElements.push(constsMngr.angTrackDisplayElementTitle(i));

    let style = getComputedStyle(document.body);
    this.defaultStyleColor = style.getPropertyValue('--default-color');

    this.currentIpColor = settings.userSettings.IpTrackColor;
    this.currentIpColorSmt = settings.userSettings.IpTrackColorSmt;
    this.currentTpColor = settings.userSettings.TpTrackColor;
    this.currentTpColorSmt = settings.userSettings.TpTrackColorSmt;
    this.currentTextColor = settings.userSettings.trackTextColor;
    this.textSize = settings.userSettings.trackTextSize;
    this.trackTextToggler = settings.userSettings.trackTextToggler;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    });

    console.log(this.slider.nativeElement);
  }

  onTrackElemBtnClick(trackElem) {
    settings.userSettings.toggleTrackElementOn(trackElem);
  }

  onSysTrackElemBtnClick(trackElem) {
    settings.userSettings.toggleSysTrackElementOn(trackElem);
  }

  onSnsTrackElemBtnClick(trackElem) {
    settings.userSettings.toggleSnsTrackElementOn(trackElem);
  }

  onAngTrackElemBtnClick(trackElem) {
    settings.userSettings.toggleAngTrackElementOn(trackElem);
  }

  onTrackTrailSliderChanged(event: MatSliderChange) {
    settings.userSettings.setTrackTrailLength(event.value);
  }

  onTrackLifeTimeSliderChanged(event: MatSliderChange) {
    settings.userSettings.setTrackLifeTime(event.value);
  }

  trackTrailMaxLength() {
    return aspSettings.trackTrailMaxDuration;
  }

  // track life time stuff
  trackLifeTimeMaxTime() {
    return aspSettings.trackLifeTimeMaxTime;
  }

  // color button ip
  isColorPickerActive() {
    return this.colorPickerSvc.isColorPickerShown();
  }

  async onIpColorClick() {
    let color = await this.colorPickerSvc.showColorPicker(this.ipColorButton, this.currentIpColor);
    if (color) {
      this.currentIpColor = color;
      settings.userSettings.setIpColor(color);
    }
  }

  async onIpColorClickSmt() {
    let color = await this.colorPickerSvc.showColorPicker(this.ipColorButtonSmt, this.currentIpColorSmt);
    if (color) {
      this.currentIpColorSmt = color;
      settings.userSettings.setIpColorSmt(color);
    }
  }

  colorPickerIconColorIp() {
    return `linear-gradient(${this.currentIpColor}, ${this.defaultStyleColor})`;
  }

  colorPickerIconColorIpSmt() {
    return `linear-gradient(${this.currentIpColorSmt}, ${this.defaultStyleColor})`;
  }

  async onTpColorClick() {
    let color = await this.colorPickerSvc.showColorPicker(this.tpColorButton, this.currentTpColor);
    if (color) {
      this.currentTpColor = color;
      settings.userSettings.setTpColor(color);
    }
  }

  async onTpColorClickSmt() {
    let color = await this.colorPickerSvc.showColorPicker(this.tpColorButtonSmt, this.currentTpColorSmt);
    if (color) {
      this.currentTpColorSmt = color;
      settings.userSettings.setTpColorSmt(color);
    }
  }

  colorPickerIconColorTp() {
    return `linear-gradient(${this.currentTpColor}, ${this.defaultStyleColor})`;
  }

  colorPickerIconColorTpSmt() {
    return `linear-gradient(${this.currentTpColorSmt}, ${this.defaultStyleColor})`;
  }

  // Slider Stuff

  minBrightness() {
    return 0;
  }

  maxBrightness() {
    return 100;
  }

  //Opacity for IP
  ipBrightnessSliderChanged(event: MatSliderChange) {
    settings.userSettings.setIpFillOpacity(event.value / 100.0);
  }

  //Opacity for TP
  tpBrightnessSliderChanged(event: MatSliderChange) {
    settings.userSettings.setTpFillOpacity(event.value / 100.0);
  }

  async onTextColorClick() {
    let color = await this.colorPickerSvc.showColorPicker(this.trackTextColorButton, this.currentTextColor);
    if (color) {
      this.currentTextColor = color;
      settings.userSettings.setTrackTextColor(color);
    }
  }

  colorPickerIconTextColor() {
    return `linear-gradient(${this.currentTextColor}, ${this.defaultStyleColor})`;
  }

  //Track text size
  trackTextSizeSliderChanged(event: MatSliderChange) {
    settings.userSettings.setTrackTextSize(event.value);
  }

  onTrackTextToggler() {
    this.trackTextToggler = !this.trackTextToggler;
    settings.userSettings.setTrackTextToggler(this.trackTextToggler);
  }
}
